import {CLIENT_COMP_VERSION} from "../version";

// Global logger interface - can be overridden
export let globalLogger: any = console;

// Function to override the global logger
export function setGlobalLogger(logger: any): void {
  globalLogger = logger;
}

export class Logger {
  public debug: (...args: any[]) => void;
  public info: (...args: any[]) => void;
  public warn: (...args: any[]) => void;
  public error: (...args: any[]) => void;

  constructor(klass: string, instanceId?: any) {
    const timestamp = function() {}
    timestamp.toString = function() {
      return new Date().toISOString()
    }

    let s = `${klass}(${CLIENT_COMP_VERSION}`;
    s += (instanceId) ? `/${instanceId})` : ')';

    // Use the global logger instance
    if( globalLogger === console ) {
      this.debug = globalLogger.debug.bind(globalLogger, '%s', timestamp, s);
      this.info = globalLogger.info.bind(globalLogger, '%s', timestamp, s);
      this.warn = globalLogger.warn.bind(globalLogger, '%s', timestamp, s);
      this.error = globalLogger.error.bind(globalLogger, '%s', timestamp, s);
    } else {
      this.debug = globalLogger.debug.bind(globalLogger, s);
      this.info = globalLogger.info.bind(globalLogger, s);
      this.warn = globalLogger.warn.bind(globalLogger, s);
      this.error = globalLogger.error.bind(globalLogger, s);
    }
  }
}
